import React, { useState, useEffect } from "react";
import { Table, Modal, Button } from "react-bootstrap";
import {
  getProvincias,
  deleteProvincia,
  putProvincia,
} from "../helpers/rutaProvincias";
import "../css/tableclientes.css";

const TableProvincias = () => {
  const [provincias, setProvincias] = useState({
    data: [],
    loading: true,
  });

  const [show, setShow] = useState(false);
  const [provinciaSeleccionada, setProvinciaSeleccionada] = useState(null);
  const [formValues, setFormValues] = useState({
    provincia: "",
    activo: true,
  });

  useEffect(() => {
    consultaProvincias();
  }, []);

  const consultaProvincias = () => {
    getProvincias().then((datos) => {
      console.log("GET PROVINCIAS:", datos);

      setProvincias({
        data: Array.isArray(datos?.provincias)
          ? datos.provincias
          : Array.isArray(datos)
          ? datos
          : [],
        loading: false,
      });
    });
  };

  const handleClose = () => {
    setShow(false);
    setProvinciaSeleccionada(null);
    setFormValues({
      provincia: "",
      activo: true,
    });
    consultaProvincias();
  };

  const modificaProvincia = (item) => {
    console.log("PROVINCIA SELECCIONADA:", item);

    setProvinciaSeleccionada(item);
    setFormValues({
      provincia: item?.provincia || "",
      activo: typeof item?.activo === "boolean" ? item.activo : true,
    });
    setShow(true);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!provinciaSeleccionada?._id) {
      alert("No se encontró el id de la provincia");
      return;
    }

    try {
      const payload = {
        provincia: formValues.provincia,
        activo: formValues.activo,
      };

      const resp = await putProvincia(provinciaSeleccionada._id, payload);
      console.log("✅ Provincia actualizada:", resp);

      if (resp?.ok === false) {
        alert(resp?.error?.message || "Error al actualizar provincia");
        return;
      }

      handleClose();
    } catch (error) {
      console.error("❌ Error al actualizar provincia:", error);
      alert("Error al actualizar provincia");
    }
  };

  const eliminarProvincia = (id) => {
    const validar = window.confirm("¿Está seguro que desea borrar la provincia?");
    if (validar) {
      deleteProvincia(id).then((resp) => {
        console.log(resp);
        consultaProvincias();
      });
    }
  };

  return (
    <div className="table-container">
      {!provincias.loading && (
        <>
          <div className="col-12 mt-4"></div>

          <div>
            <Table striped bordered hover className="table-container">
              <thead>
                <tr className="header">
                  <th className="cli">Provincias</th>
                  <th>Modif/Eliminar</th>
                </tr>
              </thead>

              <tbody>
                {provincias.data.map((item) =>
                  item.activo ? (
                    <tr key={item._id}>
                      <td>{item.provincia}</td>
                      <td>
                        <button
                          id="acepto"
                          className="btn btn-primary"
                          onClick={() => modificaProvincia(item)}
                        >
                          <i
                            className="fa fa-pencil-square-o"
                            aria-hidden="true"
                          ></i>
                        </button>

                        <button
                          id="acepto"
                          className="btn btn-danger ml-2"
                          onClick={() => eliminarProvincia(item._id)}
                        >
                          <i className="fa fa-trash-o" aria-hidden="true"></i>
                        </button>
                      </td>
                    </tr>
                  ) : null
                )}
              </tbody>
            </Table>
          </div>

          <Modal show={show} onHide={handleClose} centered>
            <form onSubmit={handleSubmit}>
              <Modal.Header closeButton>
                <Modal.Title>Modificar Provincia</Modal.Title>
              </Modal.Header>

              <Modal.Body>
                <div className="form-group mt-2">
                  <label>Provincia</label>
                  <input
                    type="text"
                    className="form-control"
                    name="provincia"
                    required
                    maxLength="30"
                    minLength="2"
                    value={formValues.provincia}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group mt-3">
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      name="activo"
                      id="activo"
                      checked={formValues.activo}
                      onChange={handleChange}
                    />
                    <label className="form-check-label" htmlFor="activo">
                      Activo
                    </label>
                  </div>
                </div>
              </Modal.Body>

              <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                  Cancelar
                </Button>
                <Button type="submit" variant="dark">
                  Guardar
                </Button>
              </Modal.Footer>
            </form>
          </Modal>
        </>
      )}
    </div>
  );
};

export default TableProvincias;